import { Button } from '../Button';
import { SkeletonBlock } from '../SkeletonBlock';
import {
  Actions,
  Content,
  EmptyCard,
  EmptyHeading,
  Field,
  FieldLabel,
  FieldValue,
  Image,
  ImagePlaceholder,
  ImageWrapper,
  LoadingPillSlot,
  PopulatedCard,
  StatusPill,
} from './AccountBookingCard.styles';
import type { AccountBookingCardProps } from './AccountBookingCard.types';

export function AccountBookingCard(props: AccountBookingCardProps) {
  if (props.variant === 'loading') {
    const { loadingLabel = 'Loading booking' } = props;
    return (
      <PopulatedCard aria-busy="true" aria-label={loadingLabel}>
        <ImageWrapper>
          <SkeletonBlock width="100%" height="100%" />
        </ImageWrapper>
        <Content>
          <LoadingPillSlot>
            <SkeletonBlock width="80px" height="24px" borderRadius="9999px" />
          </LoadingPillSlot>
          <Field>
            <SkeletonBlock variant="text" width="30%" />
            <SkeletonBlock variant="text" width="70%" />
          </Field>
          <Field>
            <SkeletonBlock variant="text" width="40%" />
            <SkeletonBlock variant="text" width="50%" />
          </Field>
          <Actions>
            <SkeletonBlock variant="button" width="140px" />
          </Actions>
        </Content>
      </PopulatedCard>
    );
  }

  if (props.variant === 'empty') {
    const { message, ctaLabel, onCtaClick } = props;
    return (
      <EmptyCard aria-label={message}>
        <EmptyHeading>{message}</EmptyHeading>
        <Button type="button" variant="primary" onClick={onCtaClick}>
          {ctaLabel}
        </Button>
      </EmptyCard>
    );
  }

  const {
    imageUrl,
    imageAlt,
    imagePlaceholderLabel,
    status,
    statusLabels,
    dateLabel,
    dates,
    referenceLabel,
    reference,
    viewBookingLabel,
    onViewBooking,
  } = props;

  return (
    <PopulatedCard aria-label={`${statusLabels[status]} — ${reference}`}>
      <ImageWrapper>
        {imageUrl ? (
          <Image src={imageUrl} alt={imageAlt ?? ''} />
        ) : (
          <ImagePlaceholder>{imagePlaceholderLabel ?? 'No image'}</ImagePlaceholder>
        )}
      </ImageWrapper>
      <Content>
        <StatusPill data-status={status}>{statusLabels[status]}</StatusPill>
        <Field>
          <FieldLabel>{dateLabel}</FieldLabel>
          <FieldValue>{dates}</FieldValue>
        </Field>
        <Field>
          <FieldLabel>{referenceLabel}</FieldLabel>
          <FieldValue>{reference}</FieldValue>
        </Field>
        <Actions>
          <Button type="button" variant="primary" onClick={onViewBooking}>
            {viewBookingLabel}
          </Button>
        </Actions>
      </Content>
    </PopulatedCard>
  );
}
